module.exports = __webpack_public_path__ + "static/digitalelitecamp-d380a6614d6ea057da5656a0aa34436d.jpg";